import { lazy } from 'react';
import type { Routes } from '@/@types/routes';
import { ACCESS_DENIED } from '@/constants/route.constant.ts';

const othersRoute: Routes = [
  {
    key: 'accessDenied',
    path: ACCESS_DENIED,
    component: lazy(() => import('@/views/others/AccessDenied')),
    authority: [],
    meta: {
      pageBackgroundType: 'plain',
      pageContainerType: 'contained',
    },
  },
];

export default othersRoute;
